var flex_wrapper_controller = {
    breakpoints: {
        'slider-desktop': 1600,
        'slider-tablet': 1200,
        'slider-mobile': 768,
        'slider-mobile-small': 480,
        'slider-mobile-extra-small': 380
    },
    state: {},
    init: function(){
        $('.flex.wrapper.slider-always .flex-inner:not(.slick-initialized)').each(function(){
            jQuery(this).slick({
                arrows: true,
                prevArrow: '<button type="button" class="icon-navigate_before" aria-label="previous"></button>',
                nextArrow: '<button type="button" class="icon-navigate_next" aria-label="next"></button>',
                autoplay: true,
                autoplaySpeed: 7000,
                slidesToShow: 1
            });
        });
        for(var i in flex_wrapper_controller.breakpoints){
            flex_wrapper_controller.state[i] = false;
        }
        flex_wrapper_controller.actual_resize();

        $('.set-columns-to-equal-height').each(function(){
            // console.log(this)
            flex_wrapper_controller.set_columns_to_equal_height(this);
        });
    },
    set_columns_to_equal_height: function(wrapperEl){
        var max_height = 0;
        jQuery(wrapperEl).find('.content').each(function(){
            var height = jQuery(this).height();
            if(height > max_height){
                max_height = height;
            }
        });
        jQuery(wrapperEl).find('.content').each(function(){
            jQuery(this).height(max_height);
        });
    },
    actual_resize: function(){
        for(var i in flex_wrapper_controller.breakpoints){
            var selector = '.flex.wrapper.'+i+' .flex-inner';
            var resolution = flex_wrapper_controller['breakpoints'][i];
            if(flex_wrapper_controller.state[i] == false){
                if(jQuery(window).width() <= resolution){
                    var options = {
                        arrows: true,
                        prevArrow: '<button type="button" class="icon-navigate_before" aria-label="previous"></button>',
                        nextArrow: '<button type="button" class="icon-navigate_next" aria-label="next"></button>',
                        autoplay: true,
                        autoplaySpeed: 7000,
                        slidesToShow: 1,
                        responsive: {}
                    };
                    jQuery(selector + ':not(.slick-initialized)').slick(options);
                    flex_wrapper_controller.state[i] = true;
                }
            }else{
                if(jQuery(window).width() > resolution){
                    jQuery(selector+'.slick-initialized').slick('unslick');
                    flex_wrapper_controller.state[i] = false;
                }
            }
        }
    }
};

jQuery(document).ready(function(){
    flex_wrapper_controller.init();
});